const ROUTES = {
  HOME: '/',
  AUC_PAGE: '/auc',
  VIDEO_REQUESTS: '/videoPoints',
  CHAT_BOT: '/chatBot',
  TWITCH_REDIRECT: '/twitch/redirect',
  DA_REDIRECT: '/da/redirect',
  SKIP_WIDGET: '/skipWidget',
  LOGIN: '/login',
  SETTINGS: '/settings',
  WHEEL: '/wheel',
  HISTORY: '/history',
  HELP: '/help',
  INTEGRATION: '/integration',
  STATISTIC: '/statistic',
  STOPWATCH: '/stopwatch',
  CHAT_WHEEL: '/chatWheel/:channel',
  REQUESTS: '/requests',
  AUDIO_ROOM: '/audioRoom',
};

export default ROUTES;
